import React from 'react'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from 'components/ModalSheet'
import { DocumentManualVerificationViewModel } from './DocumentManualVerificationViewModel'
import Button from 'components/Button'
import styles from './DocumentManualVerificationModal.sass'
import { observer } from 'mobx-react'

interface DocumentManualVerificationModalProps {
  vm: DocumentManualVerificationViewModel
}

export default observer(function DocumentManualVerificationModal({
  vm,
}: DocumentManualVerificationModalProps) {
  return (
    <ModalSheet showing={vm.showing} onRequestClose={vm.close}>
      <ModalSheetHeader withCloseButton></ModalSheetHeader>
      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalSheetContentTitle>
            <span className={styles.title}>
              Are you sure this is the right file?
            </span>
          </ModalSheetContentTitle>

          <ModalSheetContentDescription>
            The document contains the name{' '}
            <strong>{vm.documentContentClientName}</strong>, which does not
            match the expected client. Are you sure this is the right file?
          </ModalSheetContentDescription>

          <div className={styles.viewDocumentLink}>
            <Button type="secondary" onClick={vm.viewDocument}>
              View Document
            </Button>
          </div>

          {!vm.hasViewedDocument && (
            <ModalSheetContentDescription>
              Please view the document before confirming or deleting.
            </ModalSheetContentDescription>
          )}
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button disabled={!vm.hasViewedDocument} onClick={vm.confirmDocument}>
            Yes, it's the right file
          </Button>
          <Button
            type="danger"
            disabled={!vm.hasViewedDocument}
            onClick={vm.deleteDocument}
          >
            No, delete it
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})
